import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrderService } from 'src/app/services/order.service';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-qty',
  templateUrl: './qty.component.html',
  styleUrls: ['./qty.component.scss']
})
export class QtyComponent implements OnInit {
  @Input() value: number = 0;
  @Input() min: number = 0;
  @Input() max: number = 99;
  @Input() target: any = null;
  @Input() allowAdd: boolean = true;
  @Input() allowRemove: boolean = true;
  @Output() change = new EventEmitter<QtyEventType>();

  constructor(private orderService: OrderService, private alertService: AlertService) {}

  public ngOnInit(): void {}

  public add(): void {
    var ticketAtlanta = this.orderService.getAllTickets().filter((re): any => {
      if (re.id == "440b4e15-8157-46a7-9f52-c562fa651ad7" && this.target.id == "440b4e15-8157-46a7-9f52-c562fa651ad7" ) {
        return re
      }
    })

    if (ticketAtlanta.length >=2) {  
      this.alertService.toast({
        icon: 'error',
        title: 'Erro',
        text: 'Só é permitido adicionar um ingresso',
      });   
      return 
    }

    if (this.allowAdd && (this.max === null || this.value < this.max)) {
      this.value++;
    }
    this.change.emit({
      target: this.target,
      qty: this.value,
      action: 'add'
    });
  }

  public remove(): void {
    if (this.allowRemove && this.min !== null && this.value > this.min) {
      this.value--;
    }
    this.change.emit({
      target: this.target,
      qty: this.value,
      action: 'remove'
    });
  }
}

export type QtyEventType = {
  target: any;
  qty: number;
  action: 'add' | 'remove';
}
